






















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api';

import dayjs from 'dayjs';
import VueClipboards from 'vue-clipboards';
Vue.use(VueClipboards);

/**
 * item详情模块
 *
 * @author liyuyao
 * @date 09/06/2019
 */
@Component
export default class ItemDetail extends Vue {
    @Prop({ default: 0 })
    itemId: number;

    currentRgInfo: any = {};

    @Watch('itemId', { immediate: true })
    onItemIdChange() {
        this.getRgDetail();
    }

    linkFilter(link: string) {
        if (!link) {
            return '';
        }
        return link.replace(/\+/g, '%2B');
    }
    onCopy() {
        return this.linkFilter(this.currentRgInfo.link);
    }
    async getRgDetail() {
        if (!this.itemId) {
            return;
        }
        try {
            const res = await api.ctiApi.getRgDetail(this.itemId);
            this.currentRgInfo = res.data;
            this.$emit('auth', this.currentRgInfo.permission);
        } catch (e) {
            console.log(e);
        }
    }
    getCreateTime(time: number) {
        return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    }
    handleCopySuccess() {
        this.$mtd.message({
            message: '复制TT链接成功',
            type: 'success'
        });
    }
    createTT(link) {
        window.open(link);
    }
}
